const W = 300;
const H = 150;

// Top-down car outline (front on the right)
const CarShape = () => (
  <g fill="none" stroke="#333" strokeWidth="1.6">
    <rect x="20" y="25" width="260" height="100" rx="38" />
    <path d="M95 33 L120 50 L205 50 L225 33" />
    <path d="M95 117 L120 100 L205 100 L225 117" />
    <rect x="120" y="50" width="85" height="50" rx="8" />
    <path d="M225 50 Q248 75 225 100" />
    <path d="M95 50 Q78 75 95 100" />
    <rect x="45" y="14" width="40" height="11" rx="4" /><rect x="205" y="14" width="40" height="11" rx="4" />
    <rect x="45" y="125" width="40" height="11" rx="4" /><rect x="205" y="125" width="40" height="11" rx="4" />
    <text x="290" y="79" fontSize="9" fill="#777" stroke="none" textAnchor="middle" transform="rotate(90 290 79)">ANTERIORE</text>
    <text x="10" y="79" fontSize="9" fill="#777" stroke="none" textAnchor="middle" transform="rotate(-90 10 79)">POSTERIORE</text>
  </g>
);

export const CarDamageDiagram = ({ title, marks = [], onChange, testid }) => {
  const add = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    onChange([...marks, [Math.round(((e.clientX - r.left) / r.width) * W), Math.round(((e.clientY - r.top) / r.height) * H)]]);
  };
  const remove = (i, e) => { e.stopPropagation(); onChange(marks.filter((_, j) => j !== i)); };
  return (
    <div className="flex-1 min-w-0" data-testid={testid}>
      <div className="text-[8.5px] uppercase tracking-wider text-neutral-500 font-semibold mb-1 flex justify-between">
        <span>{title}</span><span className="no-print normal-case tracking-normal">tocca per segnare un danno ({marks.length})</span>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} onClick={add} className="w-full border border-neutral-300 rounded cursor-crosshair bg-white">
        <CarShape />
        {marks.map(([x, y], i) => (
          <g key={`${x}-${y}-${i}`} onClick={(e) => remove(i, e)} className="cursor-pointer" data-testid={`${testid}-mark-${i}`}>
            <circle cx={x} cy={y} r="9" fill="#E63946" fillOpacity="0.15" stroke="#E63946" strokeWidth="1.5" />
            <text x={x} y={y + 3.5} fontSize="10" fontWeight="bold" fill="#E63946" textAnchor="middle">{i + 1}</text>
          </g>
        ))}
      </svg>
    </div>
  );
};
